/*
 * Copyright (C) 2019 SADE Innovations Oy - All Rights Reserved
 *
 * NOTICE: This software is owned by SADE Innovations Oy and licensed under SADE Booster license.
 * All dissemination, usage, modification, copying, reproduction, selling and distribution of the
 * software and its intellectual and technical concepts are strictly forbidden without a valid license.
 * Such license can be obtained by issuing a SADE Booster License agreement from SADE Innovations Oy
 * (https://sadeinnovations.com).
 */
import { WallStationCDOHWStateProperties } from "./WallStationCDOHWStateProperties";
import { WallStationCDOHWState } from "./WallStationCDOHWState";
import { ConnectivityUnitHW } from "../ConnectivityUnitHW/ConnectivityUnitHW";
export class WallStationCDOHW extends ConnectivityUnitHW {
    constructor(backend, params) {
        super(WallStationCDOHW.type, backend, params);
    }
    createState(timestamp, version, reported, desired, connectionState) {
        return new WallStationCDOHWState(this.getId(), new WallStationCDOHWStateProperties(reported !== null && reported !== void 0 ? reported : {}), new WallStationCDOHWStateProperties(desired !== null && desired !== void 0 ? desired : {}), timestamp, version, connectionState);
    }
    static instanceOf(device) {
        return device instanceof WallStationCDOHW;
    }
}
WallStationCDOHW.type = "WallStation_CDO";
